import { PopupResultHandler } from '../types';

const AUTH_RETRY_COUNT = 30; // 30 retries by default
const AUTH_RETRY_INTERVAL = 1000; // 1 second retry interval
const CAMPAIGN_CLOSE_POPUP_PATH = '/campaign/closepopup';

export const invokeAuthenticationPopup = (
  url: string,
  onPopupSuccess: () => void,
  onPopupFailure: (currentLocation: Location | string) => void,
  redirectionUrl = CAMPAIGN_CLOSE_POPUP_PATH,
  retryCount = AUTH_RETRY_COUNT,
  retryInterval = AUTH_RETRY_INTERVAL,
) => {
  let interval: number;

  const authenticationWindow: Window | null = window.open(
    url,
    'msa-authentication-popup',
    'popup=1,top=300,left=300,height=400,width=400',
  );

  const handlePopupResult: PopupResultHandler = (currentLocation: Location) => {
    if (currentLocation.pathname === redirectionUrl) {
      if (onPopupSuccess) {
        onPopupSuccess();
      }
    } else if (onPopupFailure) {
      onPopupFailure(currentLocation);
    }
    clearInterval(interval);
  };

  if (
    (!authenticationWindow
      || authenticationWindow.closed
      || typeof authenticationWindow.closed === 'undefined')
      && onPopupFailure
  ) {
    onPopupFailure(redirectionUrl);
  } else {
    let timesRun = 0;
    interval = window.setInterval(() => {
      try {
        timesRun += 1;
        const currentLocation = authenticationWindow!.location;
        if (timesRun === retryCount) {
          clearInterval(interval);
        }

        if (authenticationWindow && authenticationWindow.closed) {
          handlePopupResult(currentLocation);
        }

        if (
          authenticationWindow
            && currentLocation.pathname === redirectionUrl
        ) {
          authenticationWindow.close();
          handlePopupResult(currentLocation);
        }
      } catch (e) {
        // Cross domain access error
      }
    }, retryInterval);
  }
};
